module.exports = __webpack_public_path__ + "static/img/slide_3_en.f410d37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/slider/slide_3_en.svg
// module id = ckBf
// module chunks = 0